$(document).ready(function(){
	if( typeof avgDownloadLink !== 'undefined') {
		setTimeout(
			function(){
				// This is the moment the download actually starts, so it's where product_downloaded
				// belongs. If genDL.js hasn't run yet, leave a marker behind instead -- it fires the
				// event itself on init (see genDLThankYouDownloadPending there).
				if( typeof window.genDLThankYouDownload === 'function') {
					window.genDLThankYouDownload();
				} else {
					window.genDLThankYouDownloadPending = true;
				}
				window.location = encodeURI( avgDownloadLink );
			}
			,1000
		);
	}
});
